//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CheckoutDto } from '../../landing/dto/CheckoutDto';
import { IApiRequest } from '../../IApiRequest';
import { CheckoutUrlsDto } from '../../landing/dto/CheckoutUrlsDto';

export class CheckoutPackageRequest extends IApiRequest<CheckoutDto>
{
	public $type = 'CheckoutPackageRequest';
	constructor(public data: { packageSlug: string, checkoutUrls: CheckoutUrlsDto }) { super(); }
}
